















































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CustomerContactInfo } from '@/models/filebunker/deal';
import { Base } from './base';
import { dealService } from '@/shared';
import { mask } from 'vue-the-mask';

@Component({
  computed: {
    trigger: {
      get() {
        return this.$props.flag;
      },
      set(val) {
        this.$emit('closedialog', val);
      },
    },
    selectedPhoneType: {
      get() {
        switch (this.selectedType) {
          case 'rdHomePhone':
            if (
              this.customerInfo.homePhone &&
              this.customerInfo.homePhone !== '0'
            ) {
              this.contactAt = this.customerInfo.homePhone;
              this.selectedType = 'rdHomePhone';
            }
            break;
          case 'rdBusinessPhone':
            if (
              this.customerInfo.businessPhone &&
              this.customerInfo.businessPhone !== '0'
            ) {
              this.contactAt = this.customerInfo.businessPhone;
            }
            this.selectedType = 'rdBusinessPhone';
            break;
          case 'rdCellPhone':
            if (
              this.customerInfo.cellPhone &&
              this.customerInfo.cellPhone !== '0'
            ) {
              this.contactAt = this.customerInfo.cellPhone;
            }
            this.selectedType = 'rdCellPhone';
            break;
          case 'rdEmail':
            if (this.customerInfo.email1) {
              this.contactAt = this.customerInfo.email1;
            }
            this.selectedType = 'rdEmail';
            break;
          case 'rdOther':
            this.contactAt = this.customerInfo.other;
            this.selectedType = 'rdOther';
            break;
          default:
            this.contactAt = '';
            this.selectedType = 'rdOther';
        }
        return this.selectedType;
      },
      set(val) {
        this.selectedType = val;
      },
    },
  },
  props: ['customerInfo', 'flag', 'dealId', 'amountToBePaid', 'loading', 'isSendPaymentReceipt', 'isOverrideCCFeeApplied', 'byPassReason'],
  directives: {
    mask,
  },
})
export default class SendPaymentLinkComponent extends Base {
  public selectedPhoneType: string;
  public trigger: boolean;
  public email: string = '';
  public dealId: string;
  public amountToBePaid: string;
  public isSendPaymentReceipt: boolean;
  public isOverrideCCFeeApplied: boolean;
  public byPassReason: string;
  public customerInfo: CustomerContactInfo;
  public selectedType: string = '';
  public contactAt: string;
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;
  public mounted(): void {
    // mounted
  }

  public async sendPaymentLink(): Promise<void> {
    if (!this.contactAt || this.contactAt === '0') {
      if (this.selectedType === 'rdOther') {
        this.contactAt = this.customerInfo.other;
      }
    }
    if (this.contactAt && this.contactAt !== '0') {
      try {
        this.requestProgress = true;
        await dealService.sendPaymentLinkAsync(
          this.dealId,
          this.contactAt,
          this.amountToBePaid,
          this.isSendPaymentReceipt,
          this.isOverrideCCFeeApplied,
          this.byPassReason
        );
        this.showAlert(true, this.$t('dealSendPaymentLink.alertLinkSent'));
      } catch (e) {
        if (e.response.headers.status === '401') {
          this.showAlert(
            false,
            this.$t('dealSendPaymentLink.alertNotAuthorized')
          );
        }
      } finally {
        this.trigger = false;
        this.requestProgress = false;
      }
    } else {
      this.showAlert(false, this.$t('dealSendPaymentLink.alertRequiredField'));
    }
  }
}
